module.exports = __webpack_public_path__ + "img/sidemenu-open.5f236493.png";